import React from "react";
import { GOOGLE_MAP_EMBED_SRC } from "../constants/mapEmbed";

export function BottomContactStrip() {
  return (
    <section className="section bottom-contact">
      <div className="section-inner bottom-contact-inner">
        <div className="bottom-contact-info">
          <p className="section-eyebrow">Kontakt i lokacija</p>
          <h2 className="section-title">Uvek smo vam na raspolaganju</h2>
          <p className="section-subtitle">
            Bilo da planirate porodični ručak, intimno slavlje ili veliko venčanje,
            najbolje je da nas pozovete – zajedno ćemo pronaći idealno rešenje.
          </p>
          <div className="bottom-contact-details">
            <div>
              <h3>Telefon</h3>
              <a href="tel:034354571">034354571</a>
            </div>
            <div>
              <h3>Adresa</h3>
              <p>Kraljevačkog bataljona 267, Kragujevac</p>
            </div>
          </div>
          <a
            href="tel:034354571"
            className="btn btn-primary btn-full bottom-contact-cta"
          >
            POZOVITE NAS
          </a>
        </div>
        <div className="bottom-contact-map">
          <div className="map-wrapper" aria-label="Mapa RESTORAN KRČMA">
            <iframe
              title="Mapa RESTORAN KRČMA"
              src={GOOGLE_MAP_EMBED_SRC}
              width="600"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
